import * as React from 'react';
import { useDispatch } from 'react-redux';
import { closeWorkspaceOverlay } from 'common/store/workspaces/actions';
import { Loader } from 'semantic-ui-react';
import EditRubricsView from './EditRubricsView';
import{ MessageEventTypes } from '../../../../../rubrics/src/features/rubricEditor/types';

interface EditRubricsOverlayProps {
    rubricsContentItemId?: number;
    rubricsContentRevisionId?: number;
    mode?: string;
    enableAiAssistedMarking?: boolean;
    options?: {
        rubricsContentItemId?: number;
        rubricsContentRevisionId?: number;
        mode?: string;
        enableAiAssistedMarking?: boolean;
    };
}

const EditRubricsOverlay: React.FC<EditRubricsOverlayProps> = (props) => {
    const dispatch = useDispatch();
    const [isIframeLoaded, setIsIframeLoaded] = React.useState(false);

    const rubricsContentItemId = props?.rubricsContentItemId || props?.options?.rubricsContentItemId;
    const rubricsContentRevisionId = props?.rubricsContentRevisionId || props?.options?.rubricsContentRevisionId;
    const mode = props?.mode || props?.options?.mode;
    const enableAiAssistedMarking = props?.enableAiAssistedMarking ?? props?.options?.enableAiAssistedMarking;

    const handleClose = React.useCallback(() => {
        setTimeout(()=>{ dispatch(closeWorkspaceOverlay()); }, 2000);
    }, [dispatch]);

    const handleIframeLoaded = () => {
        setIsIframeLoaded(true);
    };

    React.useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== window.location.origin) {
                return;
            }
            if (event.data?.type === MessageEventTypes.CLOSE_EDIT_RUBRIC_OVERLAY) {
                handleClose();
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [handleClose]);

    if (!rubricsContentItemId) {
        return null;
    }

    return (
      <>
        {!isIframeLoaded && <Loader />}
        <EditRubricsView
            rubricsContentItemId={rubricsContentItemId}
            rubricsContentRevisionId={rubricsContentRevisionId}
            mode={mode}
            enableAiAssistedMarking={enableAiAssistedMarking}
            onIframeLoad={handleIframeLoaded}
        />
      </>
    );
};

export default EditRubricsOverlay;
